"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneDtoPagedListDtoToJSON = exports.CertificazioneDtoPagedListDtoFromJSONTyped = exports.CertificazioneDtoPagedListDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function CertificazioneDtoPagedListDtoFromJSON(json) {
    return CertificazioneDtoPagedListDtoFromJSONTyped(json, false);
}
exports.CertificazioneDtoPagedListDtoFromJSON = CertificazioneDtoPagedListDtoFromJSON;
function CertificazioneDtoPagedListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !runtime_1.exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(_1.CertificazioneDtoFromJSON)),
        'firstItemOnPage': !runtime_1.exists(json, 'firstItemOnPage') ? undefined : json['firstItemOnPage'],
        'hasNextPage': !runtime_1.exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !runtime_1.exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
        'isFirstPage': !runtime_1.exists(json, 'isFirstPage') ? undefined : json['isFirstPage'],
        'isLastPage': !runtime_1.exists(json, 'isLastPage') ? undefined : json['isLastPage'],
        'lastItemOnPage': !runtime_1.exists(json, 'lastItemOnPage') ? undefined : json['lastItemOnPage'],
        'pageCount': !runtime_1.exists(json, 'pageCount') ? undefined : json['pageCount'],
        'pageNumber': !runtime_1.exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !runtime_1.exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalItemCount': !runtime_1.exists(json, 'totalItemCount') ? undefined : json['totalItemCount'],
    };
}
exports.CertificazioneDtoPagedListDtoFromJSONTyped = CertificazioneDtoPagedListDtoFromJSONTyped;
function CertificazioneDtoPagedListDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(_1.CertificazioneDtoToJSON)),
        'firstItemOnPage': value.firstItemOnPage,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
        'isFirstPage': value.isFirstPage,
        'isLastPage': value.isLastPage,
        'lastItemOnPage': value.lastItemOnPage,
        'pageCount': value.pageCount,
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalItemCount': value.totalItemCount,
    };
}
exports.CertificazioneDtoPagedListDtoToJSON = CertificazioneDtoPagedListDtoToJSON;
